import { ContentHeader } from "../components/ContentHeader";
import { useData } from "../data/DataContext";
import { OPERATIONS } from "../nav";

export function DoraTab() {
  const meta = OPERATIONS.find((e) => e.id === "dora")!;
  const { dora } = useData();

  if (!dora || !dora.overall) {
    return (
      <>
        <ContentHeader title={meta.label} description={meta.desc} />
        <div className="empty">
          No DORA snapshot. Run <code>python3 tools/dora-snapshot.py</code> to generate <code>dora.json</code>.
        </div>
      </>
    );
  }

  const o = dora.overall;
  return (
    <>
      <ContentHeader title={meta.label} description={meta.desc} />
      <div className="dora-cards">
        <Card label="Deploy frequency"
              value={o.deploy_frequency != null ? `${o.deploy_frequency}/day` : "—"}
              sub={`${o.deploys_total ?? 0} in ${o.window_days}d`}
              title="How often you ship to prod"
              cls={scoreClassDeploy(o.deploy_frequency)} />
        <Card label="Lead time"
              value={o.lead_time_min != null ? `${o.lead_time_min}m` : "—"}
              sub={o.lead_time_note ?? ""}
              title="Commit → prod time" cls="score-good" />
        <Card label="Change failure"
              value={o.change_failure_rate != null ? `${Math.round(o.change_failure_rate * 100)}%` : "—"}
              sub={`${(o.by_severity?.SEV1 ?? 0) + (o.by_severity?.SEV2 ?? 0)} SEV1+SEV2 / ${o.deploys_total ?? 0} deploys`}
              title="% of deploys that caused an incident — lower is better; elite <15%"
              cls={scoreClassCFR(o.change_failure_rate)} />
        <Card label="MTTR"
              value={o.mttr_minutes != null ? `${o.mttr_minutes}m` : "—"}
              sub={`${o.incidents_total ?? 0} incidents in ${o.window_days}d`}
              title="Mean Time To Recovery — average incident resolution time; lower is better"
              cls={scoreClassMTTR(o.mttr_minutes)} />
      </div>

      {dora.teams.length > 0 && (
        <>
          <div className="section-header"><h2>By team</h2><span className="count">{dora.teams.length}</span></div>
          <table className="cov-matrix">
            <thead>
              <tr>
                <th>Team</th><th>Services</th><th>Deploys (30d)</th><th>Incidents</th>
                <th title="Change Failure Rate" style={{ cursor: "help" }}>CFR</th>
                <th title="Mean Time To Recovery" style={{ cursor: "help" }}>MTTR</th>
              </tr>
            </thead>
            <tbody>
              {dora.teams.map((t) => {
                const cfr = t.change_failure_rate;
                const cls = cfr == null ? "unknown" : cfr <= 0.15 ? "yes" : "no";
                return (
                  <tr key={t.team}>
                    <td><code style={{ fontFamily: "var(--font-mono)" }}>{t.team}</code></td>
                    <td>{(t.services ?? []).length}</td>
                    <td>{t.deploys}</td>
                    <td>{t.incidents}</td>
                    <td className={`cov-cell ${cls}`}>{cfr != null ? Math.round(cfr * 100) + "%" : "—"}</td>
                    <td>{t.mttr_minutes != null ? t.mttr_minutes + "m" : "—"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      )}

      <div style={{ marginTop: 18, fontSize: 11.5, color: "var(--text-muted)" }}>
        Snapshot from <code>command-center/dora.json</code>. Refresh: <code>python3 tools/dora-snapshot.py</code>.
      </div>
    </>
  );
}

function Card({ label, value, sub, cls, title }: { label: string; value: string; sub: string; cls: string; title?: string }) {
  return (
    <div className={`dora-card ${cls}`} title={title} style={title ? { cursor: "help" } : undefined}>
      <div className="dora-label">{label}</div>
      <div className="dora-value">{value}</div>
      <div className="dora-sub">{sub}</div>
    </div>
  );
}
function scoreClassDeploy(f: number | null) { if (f == null) return "score-fair"; if (f >= 1) return "score-strong"; if (f >= 0.14) return "score-good"; return "score-poor"; }
function scoreClassCFR(c: number | null)    { if (c == null) return "score-fair"; if (c <= 0.05) return "score-strong"; if (c <= 0.15) return "score-good"; return "score-poor"; }
function scoreClassMTTR(m: number | null)   { if (m == null) return "score-fair"; if (m <= 60) return "score-strong"; if (m <= 24*60) return "score-good"; return "score-poor"; }
